module.exports = __webpack_public_path__ + "files/8a237bc56e1e2ddacaa7a194f4d28986.png";


//////////////////
// WEBPACK FOOTER
// ./images/appIcons.png
// module id = 2483
// module chunks = 0